/**
 * Returns the Trinidad y Tobado states list to populate the select item.
 */
 export function gluky_addressfield_tt_states_list() {
  let temporalStates = [];
  const states =
  {
    '01': 'Arima',
    '02': 'Chaguanas',
    '03': 'Point Fortin',
    '04': 'Port of Spain',
    '05': 'San Fernando',
    '06': 'Couva-Tabaquite-Talparo',
    '07': 'Diego Martin',
    '08': 'Penal-Debe',
    '09': 'Princes Town',
    '10': 'Rio Claro-Mayaro',
    '11': 'San Juan-Laventille',
    '12': 'Sangre Grande',
    '13': 'Siparia',
    '14': 'Tunapuna-Piarco',
    '15': 'Tobago'
  }
  Object.keys(states).map((res) => {
    temporalStates = [
      ...temporalStates,
      {
        name: states[res],
        code: res,
      },
    ];
  });
  return temporalStates;
}

/**
 * Returns the Trinidad y Tobago cities list by state code to populate the select item.
 *
 * @param $state_code
 *   The DANE state code
 * @return
 */
 export function gluky_addressfield_tt_cities_list($state_code) {
  let temporalCities = [];
  const $data =
  {
    '01':
    {
      '01001': 'Arima',
      '01002': 'Davis Courts',
      '01003': 'Maturita',
    },

    '02':
    {
      '02004': 'Cacandee Settlement',
      '02005': 'Chaguanas',
      '02006': 'Charlieville',
      '02007': 'Cunupia',
      '02008': 'Edinburgh 500',
      '02009': 'Edinburgh Gardens',
      '02010': 'Endeavour',
      '02011': 'Enterprise',
      '02012': 'Esmeralda',
      '02013': 'Felicity',
      '02014': 'Homeland Gardens',
      '02015': 'Jerningham Juntion',
      '02016': 'Lange Park',
      '02017': 'Mon Plaisir',
      '02018': 'Monroe Settlement',
      '02019': 'Montrose',
      '02020': 'Petersfield',
      '02021': 'Saint Charles',
      '02022': 'Saint Thomas',
    },

    '03':
    {
      '03023': 'Atlantic LNG',
      '03024': 'Clifton Hill',
      '03025': 'Egypt Village',
      '03026': 'Fanny Village',
      '03027': 'Gonzales',
      '03028': 'Guapo',
      '03029': 'Newlands',
      '03030': 'Point Fortin',
      '03031': 'Point Fortin',
      '03032': 'Point Ligoure',
      '03033': 'Teschier Village',
    },

    '04':
    {
      '04034': 'Dibe',
      '04035': 'Macurapo',
      '04036': 'Port of Spain',
      '04037': 'Port of Spain Downtown',
      '04038': 'Saint Clair',
      '04039': 'Saint James',
    },

    '05':
    {
      '05040': 'Broadway',
      '05041': 'Marabella',
      '05042': 'Mon Repos',
      '05043': 'Saint Joseph',
      '05044': 'San Fernando',
    },

    '06':
    {
      '06045': 'Parrish',
      '06046': 'Saint Mary',
      '06047': 'Saint Paul',
    },

    '07':
    {
      '07048': 'Blue Basin',
      '07049': 'Blue Range',
      '07050': 'Cameron',
      '07051': 'Carenage',
      '07052': 'Chaguaramas Golf Course',
      '07053': 'Chaguarams',
      '07054': 'Coco',
      '07055': 'Coolie Block',
      '07056': 'Diamond Vale',
      '07057': 'Diego Martin',
      '07058': 'Fond Palmiste Bay',
      '07059': 'Four Roads',
      '07060': 'Fuller Bay',
      '07061': 'Goodwood Park',
      '07062': 'Green Hill',
      '07063': 'Haleland Park',
      '07064': 'La Finnete',
      '07065': 'La Retraite',
      '07066': 'Mahaut Bay',
      '07067': 'Mal D Estomac Bay',
      '07068': 'Maraval',
      '07069': 'Mont Pleasant',
      '07070': 'Petir Valley',
      '07071': 'Pierre Bay',
      '07072': 'River Estate',
      '07073': 'Saint Cite Bay',
      '07074': 'Saint Peters Bay',
      '07075': 'Scotland Bay',
      '07076': 'Victoria Gardens',
      '07077': 'Westmoorings',
    },

    '08':
    {
      '08078': 'Barrackpore',
      '08079': 'Bronte',
      '08080': 'Cannan',
      '08081': 'Concord',
      '08082': 'Debe',
      '08083': 'Diamond',
      '08084': 'Duncan Village',
      '08085': 'Duncan Village',
      '08086': 'Golconda',
      '08087': 'Green Acres',
      '08088': 'Gulf View',
      '08089': 'Hermitage',
      '08090': 'La Romain',
      '08091': 'Les Efforts East',
      '08092': 'Monkey Tow',
      '08093': 'Morne Diablo',
      '08094': 'Penal',
      '08095': 'Picton',
      '08096': 'Rambert',
      '08097': 'Sadhoowa',
      '08098': 'Victoria',
      '08099': 'Woodlands',
    },

    '09':
    {
      '09100': 'Aum Shanti',
      '09101': 'Basse Terre',
      '09102': 'Bonne Terre',
      '09103': 'Buen Intento',
      '09104': 'Busy Corner',
      '09105': 'Cipero-Sainte Croix',
      '09106': 'Corinth',
      '09107': 'Eckel Village',
      '09108': 'Fifth Company',
      '09109': 'Fonrose',
      '09110': 'Gasparillo',
      '09111': 'Gordon Settlement',
      '09112': 'Hardbargain',
      '09113': 'Hindustan',
      '09114': 'Iere',
      '09115': 'Indian Walk',
      '09116': 'Kelly Juntion',
      '09117': 'La Carriere',
      '09118': 'La Lune',
      '09119': 'Lengua',
      '09120': 'Mairad Village',
      '09121': 'Marabella',
      '09122': 'Mareau',
      '09123': 'Moos',
      '09124': 'Moruga',
      '09125': 'Mt Stewart',
      '09126': 'New Grant',
      '09127': 'Palmyra',
      '09128': 'Penal Rock',
      '09129': 'Point-a-Pierre',
      '09130': 'Preau',
      '09131': 'Princes Town',
      '09132': 'Reform',
      '09133': 'Robert',
      '09134': 'Saint George Village',
      '09135': 'Saint Julien',
      '09136': 'Saint Madeline',
      '09137': 'Sixth Company',
      '09138': 'Third Company',
      '09139': 'Union',
      '09140': 'Unis',
      '09141': 'Williamsville',
    },

    '10':
    {
      '10142': 'Bush Bush Forest Reserve',
      '10143': 'Charuma',
      '10144': 'Cuche',
      '10145': 'Ecclesville',
      '10146': 'Galeota Port',
      '10147': 'Guayaguayare',
      '10148': 'Mafeking Village',
      '10149': 'Mayaro',
      '10150': 'Nariva Swamp',
      '10151': 'Navet',
      '10152': 'Pierreville',
      '10153': 'Plaisance',
      '10154': 'Plum Mitan-Biche Farmlands',
      '10155': 'Poole',
      '10156': 'Rio Claro',
      '10157': 'Rushville',
      '10158': 'Saint Joseph',
      '10159': 'Saint Margaret',
    },

    '11':
    {
      '11160': 'Parrish',
      '11161': 'Saint George',
      '11162': 'Saint John',
    },

    '12':
    {
      '12163': 'Parrish',
      '12164': 'Saint Andrew',
      '12165': 'Saint David',
    },

    '13':
    {
      '13166': 'Parrish',
      '13167': 'Saint Patrick',
    },

    '14':
    {
      '14168': 'Arouca',
      '14169': 'Bamboo No. 2',
      '14170': 'Bangladesh',
      '14171': 'Beaulieu Avenue',
      '14172': 'Blanchisseuse',
      '14173': 'Boys Lane',
      '14174': 'Brasso Seco Village',
      '14175': 'Carapo',
      '14176': 'Casselton Avenue',
      '14177': 'Caura',
      '14178': 'Centento',
      '14179': 'Crescent Gardens',
      '14180': 'Cumuto',
      '14181': 'Curepe',
      '14182': 'D Abadie',
      '14183': 'De La Marre Avenue',
      '14184': 'Dinsley',
      '14185': 'El Dorado',
      '14186': 'Fredericl Village',
      '14187': 'Galaxy Gardens',
      '14188': 'Gran Tacarib',
      '14189': 'Kelly Village',
      '14190': 'La Resource South',
      '14191': 'La Veronica',
      '14192': 'Loango',
      '14193': 'Lopinot',
      '14194': 'Macoya',
      '14195': 'Madamas Bay',
      '14196': 'Malabar Settlement',
      '14197': 'Maracas Gardens',
      '14198': 'Maracas Savanah',
      '14199': 'Marianne River',
      '14200': 'Mariposa Gardens',
      '14201': 'Mausica',
      '14202': 'Millenium Park',
      '14203': 'Montagne Avenue',
      '14204': 'Mountain View',
      '14205': 'Murphy Bay',
      '14206': 'O Meara Industrial Estate',
      '14207': 'Ortinola',
      '14208': 'Paradise',
      '14209': 'Paria Bay',
      '14210': 'Peytonville',
      '14211': 'Piarco',
      '14212': 'Piarco Airport',
      '14213': 'Pine Ridge Heights',
      '14214': 'Poolside 2',
      '14215': 'Redhill',
      '14216': 'Saint Agustine',
      '14217': 'Saint Augustine',
      '14218': 'Saint Joseph',
      '14219': 'Santa Monica Gardens',
      '14220': 'Tacarigua',
      '14221': 'The Crossings',
      '14222': 'Trincity Industrial Estate',
      '14223': 'Trincity Industrial Estate',
      '14224': 'Tulls',
      '14225': 'Tunapuna',
      '14226': 'Valley View',
      '14227': 'Verdant Vale',
      '14228': 'Wallerfield',
      '14229': 'Warren',
    },
    '15':
    {
      '15230': 'Tobago',
    },


  }
  const cities = $data[$state_code] ? $data[$state_code] : null;
  Object.keys(cities).map((citie) => {
    temporalCities = [
      ...temporalCities,
      {
        name: cities[citie],
        code: citie,
      },
    ];
  });
  return temporalCities;
}

